import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

const SearchPayments = ({ loadPaymentsWithMobileNumber, loadPaymentsWithPaymentId }) => {
    const { register, handleSubmit, setValue } = useForm();
    const history = useHistory();
 

    const onSearch = async (data) => {
        if(validateMobileNumber(data.mobileOrPaymentid)) {
            loadPaymentsWithMobileNumber(data.mobileOrPaymentid)
        } else {
            loadPaymentsWithPaymentId(data.mobileOrPaymentid)
        }
    };

    const validateMobileNumber = (mobileNumber) => {
        const pattern = /^\d{10}$/;
        return pattern.test(mobileNumber);
      }

    return (
        <>
            <form>
                <div className="row">
                    <div className="col-md-12 mt-1">
                        <div className="d-flex justify-content-center w-100 align-items-center homeScreen__searchBox">
                            <input type="text" placeholder="Mobile Number, Payment Id" className="border-0"
                                name="mobileOrPaymentid" ref={register} />
                                <div className="d-flex btn__action">
                                    <Button type="button" variant="contained" color="primary" className="navbar__btnSearch" size="small"
                                        onClick={handleSubmit(onSearch)}>
                                        <SearchIcon className="mr-2" fontSize="small" />
                                    </Button>
                                </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

export default SearchPayments
